class HousingNav {
    
  init() {
    this.$container = $('.js-housing-info');
    this.$name = this.$container.find('.js-housing-name');
    this.$letter = this.$container.find('.js-housing-letter');
    this.$image = this.$container.find('.js-housing-image');
    this.$link = this.$container.find('.js-housing-link');
    this.$prevButton = this.$container.find('.js-prev-housing');
    this.$nextButton = this.$container.find('.js-next-housing');
    
    this.prevHousing = null;
    this.nextHousing = null;

    this.bindEvents();
  }
  
  bindEvents() {
      this.$prevButton.on('click', () => {
          this.navToPage(this.prevHousing);
      });
      this.$nextButton.on('click', () => {
          this.navToPage(this.nextHousing);
      });
  }
  
  actualize(prevHousing, nextHousing) {
      this.prevHousing = prevHousing;
      this.nextHousing = nextHousing;
      this.actualizeNavButtons();
  }
  
  actualizeNavButtons() {
      if (this.prevHousing) {
          this.$prevButton.show();
      } else {
          this.$prevButton.hide();          
      }
      if (this.nextHousing) {
          this.$nextButton.show();
      } else {
          this.$nextButton.hide();          
      }
  }
  
  updateData(data) {
      this.$name.text(data.name);
      this.$letter.text(`/ корп «${data.letter}»`);
      this.$image.attr('src', data.image);
      this.$link.attr('href', '/ajax/?q=housing_info&id=' + data.id);
  }
  
  navToPage(data) {
      if (!data) {
          return false;
      }
      this.updateData(data);
      if (data.floorId && data.sectionId && data.code) {
          window.SeligerApp.pushState('FLOOR_PAGE', {
              HOUSING_CODE: data.code,
              SECTION_ID: data.sectionId,
              FLOOR_ID: data.floorId
          }, {
              housingId: parseInt(data.id),
              id: parseInt(data.floorId)
          });
      }
      else if (data.sectionId) {
          window.SeligerApp.pushState('SECTION_PAGE', {
              HOUSING_CODE: data.code,
              SECTION_ID: data.sectionId
          }, {
              housingId: parseInt(data.id)
          });
      }
      else if (data.code) {
          window.location.href = '/housing/' + data.code + '/';
      }
  }

}

export default new HousingNav();



// WEBPACK FOOTER //
// ./js/components/HousingNav/HousingNav.js